import {getCookie} from './get-cookie';
import {COOKIE_UNSET} from 'ToolboxParams/cookies';

export default function getCookieGpdr() {
  const cookie = getCookie("chuchoteurs" + window.location.hostname + "Gpdr");
  if (cookie !== "") {
    return cookie;
  } else {
    return COOKIE_UNSET;
  }
}
